import {History} from 'history';
import {SchoolsCanAccessResponse} from "../../models/SchoolsCanAccessResponse";
import {SchoolWithAccessLevel} from "../../models/School";
import {SchoolAccessLevel, schoolAccessLevelIsAtLeast} from "../../models/SchoolAccessRecord";
import {MessageBarHelper} from "../../utils/MessageBarHelper";
import React from "react";
import {IMessageBarHelper} from "../../utils/IMessageBarHelper";
import {Redirect} from "react-router";

interface SchoolAccessCheckProps
{
    tenantId: string | null;
    schoolCode: string | null;
    minSchoolAccessLevel: SchoolAccessLevel | "tenantManager" | undefined;
    
    userIsCdbEmployee: boolean;
    schoolsCanAccess: SchoolsCanAccessResponse | undefined;
    messageBarHelper: MessageBarHelper;
    history: History;
    children(): any;
}


const noAccess = (messageBar: IMessageBarHelper): JSX.Element =>
{
    messageBar.warning("Please contact your IT support for access to this page");
    
    return (<Redirect to={"/home"}/>);
}

export default function SchoolAccessCheck(props: SchoolAccessCheckProps)
{
    if(props.minSchoolAccessLevel === undefined || props.userIsCdbEmployee)
    {
        return props.children();
    }
    
    if(!props.schoolsCanAccess)
    {
        return null;
    }
    
    if(props.schoolsCanAccess.tenantManager)
    {
        return props.children();
    }
    
    if(props.minSchoolAccessLevel === "tenantManager" && !props.schoolsCanAccess.tenantManager)
    {
        return null;
    }
    
    
    let school: SchoolWithAccessLevel | null = props.schoolsCanAccess.schoolsWithAccessLevels.filter(s => {
        return s.school.tenantId == props.tenantId && s.school.schoolCode== props.schoolCode;
    })[0];
    
    if(school === undefined)
    {
        return noAccess(props.messageBarHelper);
    }
    
    if(schoolAccessLevelIsAtLeast(school.level,props.minSchoolAccessLevel as SchoolAccessLevel))
    {
        return props.children();
    }
    else
    {
        return noAccess(props.messageBarHelper);
    }
}